import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "context/AppContext";
import ResetPassword from "subscreens/general/reset-password/resetPassword";

function SellerResetPassword() {
    const { baseUrl, Navigate } = useContext(AppContext);
    const location = useLocation();
    const [email] = useState(location.state?.email || "");
    const [otp] = useState(location.state?.otp || "");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const handleReset = (password, confirmPassword) => {

        setLoading(true);

        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);

        axios.post(`${baseUrl}/seller/otp/resetPassword`, {
            // email: email,
            // otp: otp,
            // password: password,
            // password_confirmation: confirmPassword,
        })
            .then((response) => {

                if (response.data.success) {

                    setSuccess(true);

                    Swal.fire({
                        icon: "success",
                        title: "Password Reset",
                        text: response.data.message,
                        confirmButtonText: "Go to Login"
                    }).then(() => {
                        Navigate("/seller/login");
                    });

                } else {

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: response.data.message
                    });
                }

                setLoading(false);
            })
            .catch((error) => {

                console.log(
                    "RESET PASSWORD ERROR:",
                    error.response?.data
                );

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "Something went wrong while resetting password."
                });

                setLoading(false);
            });
    };

    return (
        <ResetPassword
            email={email}
            userType="seller"
            handleReset={handleReset}
            loading={loading}
            success={success}
            loginPath="/seller/login"
        />
    );
}

export default SellerResetPassword;